import { DataObject } from "@lib/titan2/dist/api/core/data/DataObject";
import { SlingoConstants } from "../model/enum/SlingoConstants";
/*
 * ChooseCellParams.ts
 */
export class ChooseCellParams {
    constructor(cellNumber, messageAcknowledged, roomName) {
        this.cellNumber = cellNumber;
        this.messageAcknowledged = messageAcknowledged;
        this.roomName = roomName; //
    }
    liquify() {
        let data = new DataObject();
        data.putNumber(SlingoConstants.PROPERTY_CELL_NUMBER, this.cellNumber);
        data.putBoolean(SlingoConstants.PROPERTY_MESSAGE_ACKNOWLEDGED, this.messageAcknowledged);
        data.putString(SlingoConstants.PROPERTY_ROOM_NAME, this.roomName);
        return data;
    }
}
//# sourceMappingURL=ChooseCellParams.js.map